import { styled } from "goober";
import { CopyButton } from "./CopyButton";
import { highlightCode } from "./highlightCode";
import { syntaxHighlightStyles } from "./syntaxHighlightStyles";

const tokenStyles = syntaxHighlightStyles
  .map(
    ({ name, color, fontStyle }) =>
      `.tok-${name} { color: ${color};${fontStyle ? ` font-style: ${fontStyle};` : ""} }`
  )
  .join("\n  ");

const PreWrapper = styled("div")`
  position: relative;
  display: flex;
  flex-direction: column;
  &[data-fill] {
    flex: 1;
    min-height: 0;
  }
  &:hover [data-copy-button] {
    opacity: 1;
  }
  &[data-bare] [data-copy-button] {
    top: 0;
    right: 0;
  }
`;

const Pre = styled("pre")`
  background: var(--alpha4);
  border: 0.5px solid var(--border-alpha);
  border-radius: 8px;
  padding: 16px;
  overflow: auto;
  font-family: var(--font-mono);
  font-size: 10px;
  line-height: 16px;
  color: var(--text-primary);
  margin: 0;
  &[data-fill] {
    flex: 1;
    min-height: 0;
  }
  &:not([data-fill]):not([data-bare]) {
    max-height: 200px;
  }
  &[data-wrap] {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
  /* Keep room on the right for the absolutely-positioned CopyButton (24px wide,
     8px inset) so wrapped code doesn't render under it. */
  &[data-bare] {
    background: transparent;
    border: none;
    border-radius: 0;
    padding: 0 32px 0 0;
    overflow: visible;
  }
  ${tokenStyles}
`;

export function CodeBlock({
  content,
  fill,
  wrap,
  language,
  bare,
}: {
  content: string;
  fill?: boolean;
  wrap?: boolean;
  language?: string;
  // Strip the rounded container so the code fills a surrounding cell.
  bare?: boolean;
}) {
  return (
    <PreWrapper data-fill={fill || undefined} data-bare={bare || undefined}>
      <Pre
        data-fill={fill || undefined}
        data-wrap={wrap || undefined}
        data-bare={bare || undefined}
      >
        {language ? highlightCode(content, language) : content}
      </Pre>
      <CopyButton getText={() => content} />
    </PreWrapper>
  );
}
